import { useCallback, useEffect, useMemo, useState } from 'react';

import { listReceivedShares } from 'src/apis/share';
import { ShareDto } from 'src/types/share';
import { getReceivedFolderKeys, getReceivedResourceIds } from 'src/utils/share';

export default function useReceivedShares() {
  const [shares, setShares] = useState<ShareDto[]>([]);
  const [isReady, setIsReady] = useState(false);

  const refreshReceivedShares = useCallback(async () => {
    try {
      setShares(await listReceivedShares());
    } catch {
      setShares([]);
    } finally {
      setIsReady(true);
    }
  }, []);

  useEffect(() => {
    refreshReceivedShares();
  }, [refreshReceivedShares]);

  const sharedDashboardIds = useMemo(
    () => getReceivedResourceIds(shares, 'DASHBOARD'),
    [shares]
  );
  const sharedDashboardFolderKeys = useMemo(
    () => getReceivedFolderKeys(shares, 'DASHBOARD_FOLDER'),
    [shares]
  );
  const sharedCampaignIds = useMemo(
    () => getReceivedResourceIds(shares, 'CAMPAIGN'),
    [shares]
  );
  const sharedCampaignFolderKeys = useMemo(
    () => getReceivedFolderKeys(shares, 'CAMPAIGN_FOLDER'),
    [shares]
  );

  return {
    shares,
    isReady,
    refreshReceivedShares,
    sharedDashboardIds,
    sharedDashboardFolderKeys,
    sharedCampaignIds,
    sharedCampaignFolderKeys,
  };
}
